import React from 'react';

interface DashboardCardProps {
  title: string;
  onViewAll: () => void;
  children: React.ReactNode;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({ title, onViewAll, children }) => (
  <div className="dashboard-recent-card">
    <div className="dashboard-recent-card-header">
      <span className="dashboard-recent-card-title">{title}</span>
      <button className="dashboard-recent-card-link" onClick={onViewAll}>View all</button>
    </div>
    <div className="dashboard-recent-card-body">
      {children}
    </div>
  </div>
);
